// const URL_APP="http://localhost:8080/";
// const URL_API="https://sirrusmodaapi.test/api/"
// const URL_DASHBOARD="https://sirrusmodaapi.test/"

// const URL_APP="https://sirrusmoda-homologacao.web.app/";
// const URL_API="https://homologacao.sirrusmoda.app/api/"
// const URL_DASHBOARD="https://homologacao.sirrusmoda.app/"

const URL_APP="https://sirrusmoda.app/";
const URL_API="https://cloud.sirrusmoda.app/api/"
const URL_DASHBOARD="https://cloud.sirrusmoda.app/"

export default{
  URL_APP,
  URL_API,
  URL_DASHBOARD
}



// WEBPACK FOOTER //
// ./src/api/env.js